import isoCountriesLanguages from 'iso-countries-languages'
import i18n from '../i18n'
import { DEFAULT_LANGUAGE } from '../constants'
const t = i18n.getFixedT(null, "common")

const supportedLangs = isoCountriesLanguages.getSupportedLangs()
const getCurrentLanguage = () => supportedLangs.indexOf(i18n.language) > 0 ? i18n.language : DEFAULT_LANGUAGE

export const getCountries = () => isoCountriesLanguages.getCountries(getCurrentLanguage())
export const getCountry = (country = "") => isoCountriesLanguages.getCountry(getCurrentLanguage(), country.toUpperCase()) || t("unknown")